import SearchApi from '../../api/Search'
import AppConfig from "@/classes/AppConfig";
import Lytics from '../../classes/Lytics';

const state = {
  query: "",
  showMobileSearchBar: false,
  showSubHeader: false,
  filteredItems: [],
  showSearchResults: false,
  saving: null,
  categories: [],
  subCategories: [],
  searchClient: null,
  loading: false,
  hits: []
};

const getters = {
  filteredItems(state) {
    return state.filteredItems
  },

  showSearchResults(state) {
    return state.showSearchResults
  },
};

const actions = {
  async queryAlgolia({ state, rootGetters, dispatch }, query) {
    if (!rootGetters["config/features"].enhancedSearch) return;
    
    const banner = AppConfig?.AppConf?.algolia_id;
    const lang = rootGetters.language;
    const indexName = `products_${lang}_${banner}`;
    const index = state.searchClient.initIndex(indexName);

    if (query) dispatch("updateSearchQuery", query);

    let filters = `storeList:${rootGetters.storeId} AND title:${rootGetters.dealId} AND env:Production`;
    if (state.categories.length)
      filters += ` AND (${state.categories
        .map((cat) => `mainCategory${lang === "en" ? "En" : "Fr"}:"${cat}"`)
        .join(" OR ")})`;
    if (state.subCategories.length)
      filters += ` AND (${state.subCategories
        .map(
          (subCat) => `subCategory${lang === "en" ? "En" : "Fr"}:"${subCat}"`
        )
        .join(" OR ")})`;
    if (state.saving) filters += ` AND saveInt>=${state.saving}`;

    try {
      dispatch('setLoadingState', true)
      const { hits } = await index.search(query || state.query, { filters });
      console.log("Algolia search results:", hits);
      Lytics.addToEventQueue({
        item_list_name: "search",
        items: hits.map((p, i) => {
          return {
            product_id: p.sku,
            name: p.productEn || p.productFr,
            name_en: p.productEn,
            name_fr: p.productFr,
            price: p.regularPrice,
            position: i,
            sale_price: p.salePrice,
            category: p.mainCategoryEn || p.mainCategoryFr,
            category_2: p.subCategoryEn || p.subCategoryFr,
            image_url: p.productImage,
            quantity: 1,
          };
        }),
      });
      dispatch("setHits", hits);
    } catch (e) {
      dispatch("setLoadingState", false);
      console.error(e);
    }
  },

  setHits({ commit }, hits) {
    commit("SET_HITS", hits);
  },

  async filterProducts({ commit, rootGetters, rootState, dispatch }, filterQuery) {
    const currentFlyer = rootGetters["landingPage/currentFlyer"];

    const showResults = !!Object.keys(filterQuery).length;
    const enhancedSearch = rootGetters["config/features"].enhancedSearch;

    if (!showResults) {
      commit("SHOW_SEARCH_RESULTS", false);
      return;
    }

    //dispatch('setLoadingState', true, {root:true});

    if (!enhancedSearch) {
      const filteredItems = await SearchApi.Post(
        currentFlyer.title,
        rootState.currentStore,
        rootGetters.language,
        filterQuery,
        rootGetters.highlightResults
      );
      commit("UPDATE_FILTERED_ITEMS", filteredItems);
      
      const products = filteredItems.reduce((acc, item) => {
        return [...acc, ...item.products];
      }, []);
      
      Lytics.addToEventQueue({
        item_list_name: "search",
        items: products.map((p, i) => {
          return {
            product_id: p.sku,
            name: p.productEn || p.productFr,
            name_en: p.productEn,
            name_fr: p.productFr,
            price: p.regularPrice,
            position: i,
            sale_price: p.salePrice,
            category: p.mainCategoryEn || p.mainCategoryFr,
            category_2: p.subCategoryEn || p.subCategoryFr,
            image_url: p.productImage,
            quantity: 1,
          };
        }),
      });
    }

    commit("SHOW_SEARCH_RESULTS", true);
    // dispatch('setLoadingState', false, {root:true});

    filterQuery.saving ? commit("SET_SAVING", filterQuery.saving) : commit("SET_SAVING", null);
    filterQuery.category ? commit("SET_CATEGORIES", filterQuery.category) : commit("SET_CATEGORIES", []);
    filterQuery.subCategory ? commit("SET_SUBCATEGORIES", filterQuery.subCategory) : commit("SET_SUBCATEGORIES", []);

    commit("UPDATE_LOADING", 1, { root: true });
    if (enhancedSearch) {
      const filteredItems = await SearchApi.Post(currentFlyer.title, rootState.currentStore, rootGetters.language, filterQuery, rootGetters.highlightResults);
      commit("UPDATE_FILTERED_ITEMS", filteredItems);
      dispatch("queryAlgolia");
    }
    commit("UPDATE_LOADING", -1, { root: true });
  },

  async updateSearchQuery({ commit }, query) {
    commit("UPDATE_SEARCH_QUERY", query);
  },

  setSubHeaderState({ commit }, val) {
    commit("SET_SUB_HEADER_STATE", val);
  },

  toggleMobileSearchBar({ commit }) {
    commit("TOGGLE_MOBILE_SEARCH_BAR");
  },

  closeMobileSearchBar({ commit }) {
    commit("CLOSE_MOBILE_SEARCH_BAR");
  },

  setShowSearchResults({ commit }, val) {
    commit("SHOW_SEARCH_RESULTS", val);
  },

  resetQuery({ commit }) {
    commit("UPDATE_SEARCH_QUERY", "");
    commit("SHOW_SEARCH_RESULTS", false);
  },
  
  resetFilters({ commit }) {
    console.log("Reset Filters");
    commit("UPDATE_SEARCH_QUERY", "");
    commit("SHOW_SEARCH_RESULTS", false);
    commit("SET_SAVING", null);
    commit("SET_CATEGORIES", []);
    commit("SET_SUBCATEGORIES", []);
  },

  setSearchClient({ commit }, val) {
    commit("SET_SEARCH_CLIENT", val);
  },

  setLoadingState({ commit }, val) {
    commit("SET_LOADING", val);
  }
};

const mutations = {

  UPDATE_SEARCH_QUERY(state, query) {
    state.query = query;
  },

  UPDATE_FILTERED_ITEMS(state, filteredItems) {
    state.filteredItems = filteredItems
  },

  SHOW_SEARCH_RESULTS(state, value) {
    state.showSearchResults = value
  },

  TOGGLE_MOBILE_SEARCH_BAR(state) {
    state.showMobileSearchBar = !state.showMobileSearchBar;
  },

  CLOSE_MOBILE_SEARCH_BAR(state) {
    state.showMobileSearchBar = false;
  },

  SET_SUB_HEADER_STATE(state, val) {
    state.showSubHeader = val;
  },

  SET_SAVING(state, val) {
    state.saving = val;
  },

  SET_CATEGORIES(state, val) {
    state.categories = val;
  },

  SET_SUBCATEGORIES(state, val) {
    state.subCategories = val;
  },

  SET_SEARCH_CLIENT(state, val) {
    state.searchClient = val;
  },

  SET_HITS(state, hits) {
    state.hits = hits;
    state.loading = false;
  },

  SET_LOADING(state, val) {
    state.loading = val;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
